import React from 'react';
import { Link } from 'react-router-dom';


const SectionTwoThree = () => {
    return (
        <>
            <section className="complimentry-section-one ip-padding">
                <div className="container">
                    <div className="row g-lg-4 g-3 align-items-center">
                        <div className="col-md-6 wow fadeInLeft" data-wow-delay=".4s" style={{ "visibility": "visible", "animationDelay": ".4s", "animationName": "fadeInLeft" }}>
                            <div className="banner-gallery text-md-center">

                                <img style={{ "borderRadius": "8px" }} className="w-100 img-fluid" src="/images/products/jacketed-vessels/jv-main.jpg" alt="" />

                            </div>
                        </div>
                        <div className="col-md-6  wow fadeInRight" data-wow-delay=".4s" style={{ "visibility": "visible", "animationDelay": ".4s", "animationName": "fadeInRight" }}>
                            <div className="bn-content-wrapper ps-lg-4 ps-2 mt-lg-0 mt-4">
                                <h4 className="section-heading  mb-2">Built for Versatility</h4>
                                <p className="section-paragraph"><span className="text-primary-red">Unicon's</span> jacketed vessels are built for durability and reliability. Customizable with or without agitators, they use materials like mild steel, stainless steel, copper, and aluminum to meet specific application needs.</p>
                                <div className="d-flex gap-3  mt-4  ">
                                    <ul className="icon-list style-two me-3 ps-0 mb-0">
                                        <li><i className="bi bi-check-circle"></i> Sturdy Design</li>
                                        <li><i className="bi bi-check-circle"></i> Customizable Options</li>
                                        <li><i className="bi bi-check-circle"></i> Material Variety</li>

                                    </ul>
                                    <ul className="icon-list style-two d-xl-block d-none ps-0">
                                        <li><i className="bi bi-check-circle"></i>Versatile Use</li>
                                        <li><i className="bi bi-check-circle"></i> Optimized Performance</li>
                                        <li><i className="bi bi-check-circle"></i>Reliable Construction</li>
                                    </ul>
                                </div>


                                <div className="mt-3">
                                    <Link to="" className="bg-less-btn" data-bs-toggle="modal" data-bs-target="#exampleModal">Enquire Now<i className="bi bi-arrow-right ms-3"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="complimentry-section-two bg-light p-relative ip-padding">
                <div className="container">
                    <div className="row g-lg-4 g-3 align-items-center">
                        <div className="col-xl-6 col-md-6  p-relative">
                            <div className="bn-content-wrapper wow fadeInRight" data-wow-delay=".5s" style={{ "visibility": "visible", "animationDelay": ".4s", "animationName": "fadeInRight" }}>

                                <h4 className="section-heading mb-2 pe-5 pe-md-0 w-md-75 w-100 mx-auto "> Why Choose UNICON</h4>
                                <p className="section-paragraph pe-lg-4 pe-0">UNICON is your go-to provider for high-quality jacketed vessels, combining robust construction with customizable options to meet diverse application needs.</p>
                                <div className="d-flex gap-3  mt-4 ">
                                    <ul className="icon-list style-two me-3 ps-0 mb-0">
                                        <li><i className="bi bi-check-circle"></i> Durable Construction</li>
                                        <li><i className="bi bi-check-circle"></i> Customizable Designs</li>
                                        <li><i className="bi bi-check-circle"></i> Material Variety</li>
                                    </ul>
                                    <ul className="icon-list style-two d-xl-block d-none ps-0">
                                        <li><i className="bi bi-check-circle"></i> Proven Expertise</li>
                                        <li><i className="bi bi-check-circle"></i> Efficient Performance</li>
                                        <li><i className="bi bi-check-circle"></i> Dedicated Customer Support</li>
                                    </ul>
                                </div>
                                <div className="mt-4">
                                    <Link to="" className="bg-less-btn" data-bs-toggle="modal" data-bs-target="#exampleModal">Enquire Now<i className="bi bi-arrow-right ms-3"></i></Link>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6 wow fadeInLeft" data-wow-delay=".4s" style={{ "visibility": "visible", "animationDelay": ".4s", "animationName": "fadeInLeft" }}>
                            <div className="banner-gallery text-md-center ps-xl-3 mt-lg-0 mt-3">

                                <img style={{ "borderRadius": "8px" }} className="w-100 img-fluid" src="/images/products/jacketed-vessels/jv-main2.jpg" alt="" />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <style>
                {`

                .ar, .ad{
                    font-size:30px;
                }
                    .adm{
                     font-size: 18px;
                      margin-top: -18px;
                    }
                .flow-diagram {
                    display: grid;
                    grid-template-columns: 1fr 50px 1fr 50px 1fr;
                    grid-template-rows: repeat(5, auto);
                    gap: 10px;
                    align-items: center;
                    text-align: center;
                }
                .box {
                    padding: 10px;
                    border-radius:8px;
                    font-weight: 600;
                    color: #1a1a1a;
                    border: 1px solid;
                    background-color: #fff;
                    position: relative;
                }
        
        @media only screen and (max-width: 991px) {
            .icon-list.style-three {
                display: flex;
            }
            ul.icon-list.style-three li {
                align-items: center;
                margin-bottom: 0;
                text-align: center;
            }
        }
        @media only screen and (max-width: 575px) {
            .flex-sm-d-wrap {
                flex-wrap: wrap;
            }
        }
        `}
            </style>
        </>
    )
}

export default SectionTwoThree;